<template>
  <div>
    <div
      v-for="(koodi, idx) of body.eiSiirrettavatPanttikirjojenKoodit"
      :key="idx"
      class="pb-3"
    >
      <v-row class="mb-0 mx-0">
        <p>Tunnus: <span class="primary--text">{{ koodi }}</span></p>
        <v-spacer/>
        <v-btn icon @click="remove(idx)">
          <v-icon>clear</v-icon>
        </v-btn>
      </v-row>
    </div>
    <v-btn
      depressed
      color="primary"
      @click="addPledge = true"
    >
      Määritä panttikirja jota ei siirretä
    </v-btn>

    <v-dialog v-model="addPledge" max-width="500">
      <v-card>
        <v-card-title>Määritä panttikirja jota ei siirretä</v-card-title>
        <v-card-text class="pb-0">
          <v-text-field
            v-model="pledge"
            label="Panttikirjan tunniste"
            hide-details
            :rules="[rules.required]"
          />
        </v-card-text>
        <v-card-actions class="px-4 pb-4">
          <v-spacer/>
          <v-btn
            depressed
            color="primary"
            :disabled="!pledge"
            @click="addRow()"
          >
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  props: {
    body: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    pledge: '',
    addPledge: false,
    rules: {
      required: value => !!value || 'Pakollinen kenttä.',
    },
  }),
  methods: {
    addRow() {
      this.body.eiSiirrettavatPanttikirjojenKoodit.push(this.pledge);
      this.pledge = '';
      this.addPledge = false;
      this.$bus.$emit('GET_DIAS_CONFIG');
    },
    remove(idx) {
      this.body.eiSiirrettavatPanttikirjojenKoodit.splice(idx, 1);
      this.$bus.$emit('GET_DIAS_CONFIG');
    },
  },
};
</script>
